var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscussion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentcolor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.2 28.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2 6.1c0 .1-.1.2-.1.3l-.7 2H10l-.7-2-.1-.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2 0L0 15.9h17.5V0H3.2zm7.6 11c0-.3-.1-.5-.2-.8l-.2-.7H8.1l-.2.7c-.1.2-.2.5-.2.8H6.3c.1-.3.3-.6.4-.9l1.6-4.3c.1-.2.2-.5.2-.8H10c.1.3.1.5.2.8l1.6 4.3c.1.4.3.7.4.9h-1.4zM26.1 15.2c0-.3-.2-.5-.6-.5h-1.2v1.1h1.2c.2 0 .5-.2.6-.6 0 .1 0 0 0 0zM25.5 16.5h-1.2v1.3h1.2c.5 0 .7-.2.7-.7s-.2-.6-.7-.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2 8v16h10V8h-10zm5.4 10.7H23.2c0-.3.1-.6.1-.8v-3.2c0-.3 0-.5-.1-.8h2.3c1 0 1.5.4 1.5 1.2 0 .3-.1.6-.3.9-.1.1-.3.2-.4.2.2 0 .4.1.6.3.3.2.4.6.4.9-.1.8-.6 1.3-1.7 1.3zM6.1 18.9v9.5h11v-9.5h-11zm7.8 6.8c-.4.5-1 .7-1.7.7-.6 0-1.2-.2-1.7-.6-.5-.5-.7-1.2-.7-1.9s.2-1.5.8-2c.4-.4 1-.6 1.6-.6.7 0 1.3.2 1.7.8.2.2.3.5.3.7l-1 .2c0-.2-.1-.3-.2-.5-.2-.3-.5-.4-.8-.4-.3 0-.6.1-.8.3-.3.4-.5.8-.4 1.3 0 1 .5 1.7 1.3 1.7.3 0 .7-.1.9-.4.1-.2.2-.3.2-.5l1 .2c-.2.4-.3.7-.5 1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscussion);
export default __webpack_public_path__ + "static/media/discussion.54875029.svg";
export { ForwardRef as ReactComponent };